import { cx } from '@/lib/cx'

/** A spinner says "wait"; a skeleton says "a row of tiles is coming here", so
 *  the layout does not jump. */
export function Skeleton({
  variant = 'text',
  width,
  height,
}: {
  variant?: 'text' | 'card'
  width?: string
  height?: string
}) {
  return (
    <span
      className={cx(
        'block animate-pulse-soft bg-subtle',
        variant === 'card' ? 'h-25 rounded-lg' : 'h-3 rounded-sm',
      )}
      style={{ ...(width ? { width } : {}), ...(height ? { height } : {}) }}
    />
  )
}

/** One live announcement for the whole block, not one per bar. */
export function SkeletonList({ rows = 3, label }: { rows?: number; label: string }) {
  return (
    <div className="grid gap-3" role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} width={`${100 - i * 12}%`} />
      ))}
    </div>
  )
}
